import { getModule } from "vuex-module-decorators";
import { saveAs } from "file-saver";

import dataStore from "@/store";

import FileStorageStore from "./store";
import StorageItemReferenceInterface from "./storage-item-reference.interface";
import BucketFileHandlerService from "./bucket-file-handler.service";

export default class BucketFileDownloaderService {
  private fBucketFileHandlerService: BucketFileHandlerService;

  private fFileStorageDataStore: FileStorageStore;

  public constructor(bucketFileHandlerService: BucketFileHandlerService) {
    this.fBucketFileHandlerService = bucketFileHandlerService;
    this.fFileStorageDataStore = getModule(FileStorageStore, dataStore);
  }

  public async download(
    file: StorageItemReferenceInterface,
    fileName: string
  ): Promise<void> {
    const storageItem = this.fFileStorageDataStore.getItemById(
      file.storageItem
    );

    if (!storageItem) {
      return;
    }

    const originalUrl = this.fBucketFileHandlerService.getOriginalUrl(
      storageItem.key
    );

    const response = await fetch(originalUrl);

    if (!response.ok) {
      throw new Error("Fail to download the attachment");
    }

    const blobBody = await response.blob();

    saveAs(blobBody, fileName);
  }
}
